import Vue from 'vue';

const state = {
    step: 1,
    form: {},
}

const getters = {

    step: state => {
        return state.step;
    },

    form: state => {
        return state.form;
    },

}

const mutations = {

    reset(state) {
        state.step = 1;
        state.form = {};
    },

    setForm(state, form) {
        state.form = form;
    },

    setStep(state, step) {
        state.step = step;
    },

    setParam(state, param) {
        let key = Object.keys(param)[0];
        Vue.set(state.form, key, param[key]);
    },

    setElements(state, elements) {
        Vue.set(state.form, 'elements', elements);
    },

    setElement(state, element) {
        let elements = state.form.elements;
        let index = elements.indexOf(elements.find(a => a.id === element.id));
        Vue.set(elements, index, element);
    },

    removeAction(state, id) {
        let elements = state.form.elements;
        let index = elements.indexOf(elements.find(n => n.id === id));
        elements.splice(index, 1);
        Vue.set(state.form, 'elements', elements);
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}